import { Typography } from "@mui/material";
import { ActionsCell } from "../../../../../Component/Common/Components/DataTable/ActionsCell";
import { DefaultCell } from "../../../../../Component/Common/Components/DataTable/DefaultCell";
import { MerSETASdeDto } from "../../../../../Component/Model/Dto/WSP/MerSETASDE";
import { ActionType, TableColumn } from "../../../../../Component/Model/Table/Table";
import { CurrencyFormatter } from "../../../../../Helpers/CurrencyFormatter";

interface organisationExternalTrainingRows {
    startEndDate: string,
    beeCategory: string,
    interventionType: string,
    interventionTitle: string,
    courseName: string,
    attendees: JSX.Element,
    cost: string;
    actions: ActionType[];
}

interface organisationExternalTrainingTable {
    columns: Array<TableColumn>;
    rows: Array<organisationExternalTrainingRows>;
}

export function OrganisationExternalTrainingDataTable(dataObject: MerSETASdeDto[], deleteMerSetaSde: (id: number, courseName: string) => void, editMerSetaSde: (id: number) => void, handleRouteToAttendeeClick: (id: number) => void): organisationExternalTrainingTable {
    const columns = [
        { Header: 'Start - End Date', accessor: 'startEndDate', id: 'startEndDate', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'BEE Category', accessor: 'beeCategory', id: 'beeCategory', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Intervention Type', accessor: 'interventionType', id: 'interventionType', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Intervention Title', accessor: 'interventionTitle', id: 'interventionTitle', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Course Name', accessor: 'courseName', id: 'courseName', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: 'Attendees', accessor: 'attendees', id: 'attendees', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: 'Cost (excl. VAT)', accessor: 'cost', id: 'cost', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true, rightAlign: true },
        { Header: 'Actions', accessor: 'actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true }
    ];
    if (dataObject !== undefined && dataObject.length > 0) {
        const rows = dataObject.map((item: MerSETASdeDto, index: number) => ({
            startEndDate: item.startEndDate,
            beeCategory: item.beeCategory,
            interventionType: item.interventionType,
            interventionTitle: item.interventionTitle,
            courseName: item.courseName,
            attendees: (
                <Typography variant="caption" fontWeight='regular' color="#007bff"
                style={{ cursor: "pointer" }}
                onClick={() => {
                    handleRouteToAttendeeClick(item.id);
                }}>
                    {item.attendees}
                </Typography>
            ),
            cost: CurrencyFormatter(item.cost),
            actions: [
                {
                    key: index.toString(),
                    label: 'Edit',
                    action: () => {
                        editMerSetaSde(item.id);
                    },
                    icon: {
                        color: 'info',
                        name: 'edit'
                    }
                },
                {
                    key: index.toString(),
                    label: 'Delete',
                    action: () => {
                        deleteMerSetaSde(item.id, item.courseName)
                    },
                    icon: {
                        color: 'error',
                        name: 'delete'
                    }
                }
            ]
        }));
        return { columns: columns, rows: rows };
    }
    else {
        return { columns: columns, rows: [] };
    }
}
